// Shared sync store — single source of truth for Trello data.
// Persists to localStorage so navigating between pages never re-fetches.
// When a real database is added, swap the localStorage calls for API calls here.

const STORE_KEY   = 'te_sync_store';
const MAX_AGE_MS  = 30 * 60 * 1000; // 30 min cache

function load() {
  try { return JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); }
  catch { return null; }
}

function save(data) {
  localStorage.setItem(STORE_KEY, JSON.stringify({ ...data, syncedAt: Date.now() }));
}

export function getSyncedMembers()  { return load()?.members  || []; }
export function getSyncedBoards()   { return load()?.boards   || []; }
export function getNewMembers()     { return load()?.newMembers || []; }

export function isSyncStale() {
  const store = load();
  if (!store?.syncedAt) return true;
  return Date.now() - store.syncedAt > MAX_AGE_MS;
}

export function hasSyncData() {
  const store = load();
  return !!(store?.members?.length > 0 && store?.boards?.length > 0);
}

export function saveSyncData({ boards, members, newMembers = [] }) {
  save({ boards, members, newMembers });
}

export function dismissNewMember(trelloId) {
  const store = load();
  if (!store) return;
  const newMembers = (store.newMembers || []).filter(m => m.id !== trelloId);
  save({ ...store, newMembers });
}

export function clearSyncData() {
  localStorage.removeItem(STORE_KEY);
}
